export enum ResourceKey {
    KP_REGULATIONS = 'KP_REGULATIONS',
    KP_IDD = 'KP_IDD',
    KP_PERSONAL_DATA_ADMINISTRATOR_INFO = 'KP_PERSONAL_DATA_ADMINISTRATOR_INFO',
}
